const _ = require('lodash')

let initStore = {
    loading: false,
    error: false,
    /*sva*/
    errob :{
        "timestamp": "2015-08-23T02:27:18.038+0000",
        "status": 500,
        "error": "Default Error",
        "message": "500 null",
        "path": "/kk/svaddressDetailPost"
    },
    crudsuccessob :{
        "timestamp": "2015-08-23T02:27:18.038+0000",
        "status": 200,
        "error": "Default Error",
        "message": "500 null",
        "path": "/kk/svaddressDetailPost"
    },
    /*svae */
    my_data: [],
    loadingRESERVATION:false,
    errorRESERVATION:false,
  
    sj_data_room:{
        "id": "-4",
        "fname": "Ror",
        "cardId": "-4",
        "adultType": "t5",
             "childType": "m2",
        "card": "7777-1234--1234--1234" 
      },
      my_data_roomdet: {
        
        "id": "-4",
        "fname": "Ror",
        "cardId": "-4",
        "adultType": "t5",
             "childType": "m2",
        "card": "7777-1234--1234--1234" 
      }
   
    
   
    
}


export default (state = initStore, action) => {
    console.log(action);
    let januState;
    switch (action.type) {
       
        case "GET_ROOMDET_SUCCESS":
            console.log("reduce %%%%%%%%evsearcg  success*****************");
            console.log(action.payload.my_data_roomdet);
             //let januState = {...state, loading: false, my_data_roomdet: action.payload.my_data_roomdet}
            let januState = {...state,errob:null, loading: false,error:false, crud_flag:'I',my_data_geo:action.payload.my_data_geo, my_data_roomdet: action.payload.my_data_roomdet, svr_soj_images: action.payload.my_images}
            return januState
       
        case 'GET_ROOMDET_BEGIN':
            console.log("loading")
            return {...state,crud_flag:'I', error:false, loading: true}
        case 'GET_ROOMDET_ERROR':
            console.log("error")
            console.log(action.payload.errob)
            const errjson = {
                "timestamp": "2024-08-23T02:27:18.038+0000",
                "status": 500,
                "error": "Internal Server Error",
                "message": "500 null",
                "path": "/accountclient/svaddressDetailPost"
            }
            return {...state,errob:action.payload.errob,crudsuccessob:null, error: true}
        
        case "RESET_SAVEROOM_INIT":
           let  my_data_address_init = {
            "id": "-4",
            "cardId": "-4",
            "card": "7777-1234--1234--1234" 
        }
            console.log("reduce j15v%%%%%%%%RESET_SAVEROOM_INIT  success*****************");
            console.log(action)
           
            /*
            januState = {...state, crud_flag:'I', error:false, loading:false, crudsuccessob:null,my_data_geo:action.payload.my_data_geo, my_data_roomdet:my_data_address_init}
            
           */
            if(action && action.payload && action.payload.my_data_geo){
                januState = {...state, crud_flag:'I', error:false, loading:false, crudsuccessob:null,my_data_geo:action.payload.my_data_geo, my_data_roomdet:my_data_address_init}

            }else{
                januState = {...state, crud_flag:'I', error:false, loading:false, crudsuccessob:null, my_data_roomdet:my_data_address_init}

            }
            return januState
               
        case "GET_SAVEROOM_SUCCESS":
                console.log("reduce %%%%%%%%evsearcg  success*****************");
                console.log(action.payload.crudsuccessob);
                // let januState = {...state, loading: false, my_data_roomdet: action.payload.my_data_roomdet}
                 januState = {...state, crud_flag:'S', error: true,loading: false, errob:null,crudsuccessob: action.payload.crudsuccessob}
                return januState
        case "GET_SAVEROOM_BEGIN":
                    console.log("loading")
                    return {...state, crud_flag:'I',loading: true}
        case "GET_SAVEROOM_ERROR":
                    console.log("crud error")
                    console.log(action.payload.errob)
                   
                    return {...state,errob:action.payload.errob,crudsuccessob:null, error: true, crud_flag:'E'}
        
        default:
            return state
    }
}